import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ViewModelProperty } from '../../models';
import { VmpFieldType, VmpSelectionType } from '../../enums';

@Component({
    selector: 'ldw-vmp-form-group',
    templateUrl: './vmp-form-group.component.html',
    styleUrls: ['./vmp-form-group.component.css'],
    standalone: false
})
export class VMPFormGroupComponent implements OnInit {
  static groupid = 0;

  protected isInitialized = false;
  protected _vmpList: ViewModelProperty[] | undefined = undefined;
  private vmpGroupCaptionText = '';
  fldType = VmpFieldType;
  @Input() captionWidth = 100;
  @Input() captionVisible = true;
  @Input() expanded = false;
  @Input() groupCaptionText = '';
  @Input() groupCaptionVisible = true;

  @Input() form!: UntypedFormGroup;

  @Output() actionClicked = new EventEmitter<ViewModelProperty>()

  ngOnInit(): void {
    this.isInitialized = true;
    this.buildFormGroup();
  }

  @Input()
  get vmpList(): ViewModelProperty[] | undefined {
    return this._vmpList;
  }

  set vmpList(value: ViewModelProperty[] | undefined) {
    if (this._vmpList == value) {
      return;
    }
    this._vmpList = value;
    if (this.isInitialized) {
      this.buildFormGroup();
    }
  }

  get captionText(): string {
    if (!this.groupCaptionVisible) {
      return '';
    }
    if (this.groupCaptionText != '') {
      return this.groupCaptionText;
    }
    return this.vmpGroupCaptionText;
  }

  isSelect(vmp: ViewModelProperty): boolean {
    if (vmp == null) {
      return false;
    }
    return vmp.selectionType == VmpSelectionType.Select;
  }

  isButtonEdit(vmp: ViewModelProperty): boolean {
    if (vmp == null) {
      return false;
    }
    return vmp.selectionType == VmpSelectionType.ButtonEdit;
  }

  buildFormGroup(): void {
    if (this.form == null) {
      this.form = new UntypedFormGroup({});
    }

    if (this.vmpList == undefined) {
      return;
    }
    const group: any = {};
    this.vmpList.forEach((vmp) => {
      const newFieldName = vmp.fieldName.replace('.', '_');
      group[newFieldName] = vmp.required ? new UntypedFormControl([], Validators.required) : new UntypedFormControl([]);
    });
    this.getVMPGroupCaptionName();
    this.form.addControl(this.getGroupName(), new UntypedFormGroup(group));
  }

  protected getGroupName(): string {
    if (this.vmpGroupCaptionText != '') {
      return this.vmpGroupCaptionText;
    }
    const name = 'GROUP' + VMPFormGroupComponent.groupid;
    VMPFormGroupComponent.groupid = VMPFormGroupComponent.groupid + 1;
    return name;
  }

  protected getVMPGroupCaptionName() {
    this.vmpGroupCaptionText = '';
    if (this.vmpList == undefined) {
      return;
    }
    this.vmpList.forEach((vmp) => {
      if (this.vmpGroupCaptionText == '') {
        if (vmp.subGroupName !== undefined) {
          this.vmpGroupCaptionText = vmp.subGroupName;
        }
      }
    });
  }
}
